var _polygon, _polygon2, _polygon3, _polygon4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 0 63 18 63 18 18 63 18 63 0 0 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "144 0 81 0 81 18 126 18 126 63 144 63 144 0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "144 144 144 81 126 81 126 126 81 126 81 144 144 144"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 144 63 144 63 126 18 126 18 81 0 81 0 144"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.45,42.84l7.88,52.97h-14.08l-.74-9.52h-4.93l-.83,9.52h-14.24l7.03-52.97h19.91ZM58.15,76.89c-.7-6-1.4-13.41-2.1-22.25-1.4,10.14-2.28,17.56-2.64,22.25h4.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.08,69.21h-12.4v-2.91c0-3.36.39-5.95,1.16-7.77.77-1.82,2.33-3.43,4.66-4.83,2.33-1.4,5.37-2.09,9.09-2.09,4.47,0,7.84.79,10.11,2.37,2.27,1.58,3.63,3.52,4.09,5.82.46,2.3.69,7.04.69,14.21v21.79h-12.86v-3.87c-.81,1.55-1.85,2.71-3.12,3.49-1.28.78-2.8,1.16-4.56,1.16-2.31,0-4.43-.65-6.36-1.95-1.93-1.3-2.9-4.14-2.9-8.52v-3.57c0-3.25.51-5.46,1.54-6.64,1.02-1.18,3.57-2.55,7.62-4.12,4.34-1.7,6.66-2.85,6.97-3.44s.46-1.79.46-3.6c0-2.27-.17-3.75-.51-4.43-.34-.69-.9-1.03-1.68-1.03-.89,0-1.45.29-1.67.87-.22.58-.33,2.08-.33,4.5v4.55ZM91.27,75.16c-2.12,1.55-3.34,2.85-3.68,3.89-.34,1.05-.51,2.55-.51,4.51,0,2.25.15,3.7.44,4.35.29.65.88.98,1.75.98.83,0,1.37-.26,1.62-.77.25-.51.38-1.86.38-4.04v-8.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnText);
export default __webpack_public_path__ + "static/media/btn_text.2c01c3a5ef780823b1fb781e34291f1a.svg";
export { ForwardRef as ReactComponent };